interface GoogleCredentialResponse {
  credential: string;
}

export interface GoogleIdentity {
  initialize: (options: {
    client_id: string;
    nonce: string;
    auto_select: boolean;
    callback: (response: GoogleCredentialResponse) => void;
  }) => void;
  renderButton: (
    element: HTMLElement,
    options: {
      type: 'standard';
      theme: 'outline' | 'filled_black';
      size: 'large';
      text: 'continue_with';
      width: number;
    }
  ) => void;
}

function identity(): GoogleIdentity | undefined {
  return (
    window as Window & { google?: { accounts?: { id?: GoogleIdentity } } }
  ).google?.accounts?.id;
}

let loading: Promise<GoogleIdentity> | undefined;

export function loadGoogleIdentity(): Promise<GoogleIdentity> {
  const loaded = identity();
  if (loaded) return Promise.resolve(loaded);
  if (loading) return loading;
  loading = new Promise<GoogleIdentity>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    const fail = () => {
      window.clearTimeout(timer);
      script.remove();
      reject(
        new Error(
          'Google sign-in could not load. Please try again or use your password.'
        )
      );
    };
    const timer = window.setTimeout(fail, 15_000);
    script.onerror = fail;
    script.onload = () => {
      window.clearTimeout(timer);
      const api = identity();
      if (api) resolve(api);
      else fail();
    };
    document.head.appendChild(script);
  }).catch(error => {
    loading = undefined;
    throw error;
  });
  return loading;
}
